import { Toast } from 'vant';
import config from './config';
import { BlindToken } from '@/service/const/localStorageKey';


/**
 * 获得授权页链接
 */
export function getLinkToAuth(url) {
  return `${config.blackHost}/new/topic/views/sso/auth.html?returnUrl=${encodeURIComponent(url)}`;
}

/**
 * 获得授权页链接
 */
export function getLinkToAuthIndex(url) {
  return `${config.blackHost}/new/topic/views/sso/index.html?returnUrl=${encodeURIComponent(url)}`;
}

/**
 * 获取跳转登录页
 */
export function getLinkToLogin(url) {
  return `${config.blackHost}/login?refer=${encodeURIComponent(url)}`;
}

/**
 * 跳转客服页
 */
export function linkToCustomerService() {
  const url = 'https://m.black-unique.com/privilege_module/index?key=kf&_page=chat&chat_id=0';
  window.location.href = url;
}

/**
 * 获取唤起app的链接
 */
export function getCallAppLink(url = '') {
  if (url && url.length > 0) {
    return `blackUnique://url?link=${encodeURIComponent(url)}`;
  }
  return 'blackUnique://';
}


/**
 * 跳转 APP 或者引导下载
 */
let timer = null;
export function jumpAppOrDownload(url = location.href) {
  const start = Date.now();
  window.location.href = getCallAppLink(url);
  clearTimeout(timer);
  timer = setTimeout(() => {
    if (Date.now() - start < 4000) {
      window.location.href = config.grow.downloadLink;
    }
  }, 2000);
}

export function errorHandler(res, properyType = 'isSuccess') {
  if (res[properyType]) {
    return true;
  }
  Toast(res.msg || '系统繁忙，请稍后重试');
  return false;
}


/** ********************** */
export function errorChecker(res, opt) {
  if (res && opt.codeSet.has(res.code)) {
    return res.data;
  }
  if (opt.toast) {
    Toast({
      message: res.msg || res.message || '网络异常，请稍后重试',
      type: 'fail',
      duration: 3000,
    });
  }
  throw new Error(res.msg || res.message || '网络异常，请稍后重试');
}

export const apiHandler = async (requestPromise, opt = {}) => {
  const defaultHandler = {
    toast: true,
    codeSet: new Set([0, 200]),
  };
  const res = await requestPromise;
  // eslint-disable-next-line no-param-reassign
  opt = Object.assign(defaultHandler, opt);
  return errorChecker(res.data, opt);
};

export const apiHandlerWithErr = async (requestPromise, opt = {}) => {
  const defaultHandler = {
    toast: true,
    codeSet: new Set([0, 200]),
  };
    // eslint-disable-next-line no-param-reassign
  opt = Object.assign(defaultHandler, opt);
  const arr = ([null, null]);
  try {
    const res = await requestPromise;
    const data = errorChecker(res.data, opt);
    arr[1] = data;
  } catch (error) {
    arr[0] = error;
  }
  return arr;
};
